<template>
	<div class="d-flex j-center">
		<div class="content-box">
			<div class="content-left-box">
				<div class="d-flex a-center" style="box-sizing: border-box;height: 5rem;padding: 1.5rem;color: #000000;font-weight: 600;font-size: 0.875rem;">
					反馈报告列表
				</div>
				<div style="height: 50rem;box-sizing: border-box;width: 100%;overflow-y: scroll;padding:0 1.5rem;" class="list-boxs">
					<div v-for="(item,index) in cooperate_list" :key="item.mould_id" style="cursor: pointer;box-sizing: border-box;border-bottom: 1px solid #E6E9ED;padding: 0.625rem 0;">
						<div class="d-flex" style="box-sizing: border-box;">
							<div style="width: 6.25rem;height: 6.25rem;border-radius: 0.5rem;">
								<img :src="item.mould_img" style="width: 6.25rem;height: 6.25rem;border-radius: 0.5rem;" alt="">
							</div>
							<div style="flex: 1;height: 6.25rem;color: #000000;font-size: 14px;font-weight: 600;overflow: hidden;text-overflow: ellipsis;margin-left: 1rem;" class="d-flex flex-column j-sb">
								<div class="" style="overflow: hidden;text-overflow: ellipsis;white-space: nowrap;">{{item.mould_title}}</div>
								<div style="width: 100%;box-sizing: border-box;color: #1E69FF;font-size: 0.75rem;" class="d-flex a-center j-sb">
									<div @click.stop="watchDetail(item,index)">报告详情</div>
									<div class="d-flex">
										<div @click.stop="editCooperate(item,index)">编辑</div>
										<div @click.stop="delCooperate(item,index)" style="padding-left: 1.75rem;">删除</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="content-right-box">
				<div style="color: #000000;box-sizing: border-box;font-weight: 600;font-size: 0.875rem;width: 364px;">
					<div style="padding-bottom: 1rem;" class="w-100 d-flex a-center j-sb">
						发布反馈报告模板
						<div style="color: #1E69FF;font-size: 12px;font-weight: 600;">案例展示</div>
					</div>
					<div style="color: #BBBBBB;font-size: 12px;padding-bottom: 1rem;">企业发布新品试用，业务员挖掘需求单位试用体验达成合作</div>
					<div style="box-sizing: border-box;width: 100%;">
						<div style="padding-bottom: 0.625rem;">产品标题</div>
						<el-input v-model="paramData.mould_title" size="mini" style="width: 22.75rem;" placeholder="如：全新一代玻尿酸美颜试用针"></el-input>
						<div style="padding-bottom: 0.625rem;padding-top: 25px;">产品封面图</div>
						<el-upload
							class="avatar-uploader"
							style="width: 7.5rem;height: 7.5rem;"
							:action="$apiurl + 'seller/enterprise_publicity_api.php'"
							:show-file-list="false"
							name="bu_form_img"
							:data="{'act':'upload_bu_form_img'}"
							:on-success="fileSuccessImg"
							accept='.jpg,.png,.jpeg'>
							<img v-if="paramData.mould_img" :src="paramData.mould_img" class="avatar">
							<i v-else class="el-icon-plus avatar-uploader-icon"></i>
						</el-upload>
						<div style="padding-bottom: 0.625rem;padding-top: 25px;">体验时间</div>
						<el-date-picker
							style="width: 22.75rem;"
							v-model="paramData.try_time"
							type="date"
							placeholder="选择体验日期"
							size="mini"
							value-format="yyyy-MM-dd">
						</el-date-picker>
						<div style="padding-bottom: 0.625rem;padding-top: 25px;">温馨提示</div>
						<div style="box-sizing: border-box;border: 1px solid #BBBBBB;border-radius: 4px;width: 22.75rem;min-height: 12.5rem;padding: 10px;">
							<el-input type="textarea" 
							:autosize="{ minRows: 5, maxRows: 7}"
							v-model="paramData.other_tip_word"
							placeholder="填写提示内容" 
							style="color: #000000;font-size: 0.75rem;width: 100%;border: none;" 
							placeholder-style="color: #BBBBBB;font-size: 0.75rem;"></el-input>
							<div class="w-100 d-flex j-sb" style="box-sizing: border-box;margin-top: 12px;">
								<template v-if="paramData.other_tip_img.length!=0">
									<div style="width: 5rem;height: 5rem;" class="" v-for="(item,index) in paramData.other_tip_img" :key="index">
										<img :src="item" class="avatar" style="width: 5rem;height: 5rem;">
									</div>
								</template>
								<el-upload
									class="avatar-uploader"
									style="height: 5rem;"
									:action="$apiurl + 'seller/enterprise_publicity_api.php'"
									:show-file-list="false"
									name="bu_form_img"
									:data="{'act':'upload_bu_form_img'}"
									:on-success="fileSuccessOtherimg"
									accept='.jpg,.png,.jpeg'>
									<template v-if="paramData.other_tip_img.length<4">
										<i class="el-icon-plus avatar-uploader-icon" style="width: 5rem;height: 5rem;line-height: 5rem;"></i>
									</template>
								</el-upload>
							</div>
						</div>
						<div class="d-flex w-100 flex-column" style="box-sizing: border-box;margin-top: 1.25rem;" v-if="paramData.other_mould.length!=0">
							<div v-for="(item,index) in paramData.other_mould" :key="index" style="margin-bottom: 8px;">
								<div class="d-flex a-center" style="margin-bottom: 0.5rem;">
									<el-input v-model="item.title" size="mini" style="width: 22.75rem;" placeholder="请输入标题"></el-input>
									<div style="white-space: nowrap;margin-left: 10px;cursor: pointer;" @click.stop="delOtherMould(item,index)">删除</div>
								</div>
								<el-input type="textarea"
								:autosize="{ minRows: 4, maxRows: 6}"
								v-model="item.value"
								placeholder="请输入内容" 
								style="color: #000000;font-size: 0.75rem;width: 100%;border: none;" 
								placeholder-style="color: #BBBBBB;font-size: 0.75rem;"></el-input>
							</div>
						</div>
						<div style="padding-bottom: 0.625rem;padding-top: 20px;justify-content: flex-end;color: #1E69FF;cursor: pointer;" class="w-100 d-flex" @click="addOthermould">+添加模块</div>
						<div style="padding-top: 1rem;color: #BBBBBB;font-size: 0.75rem;">发布成功默认显示到企业员工企业微网站的个人中心列表</div>
						<div class="d-flex a-center" style="margin-top: 12.5rem;">
							<el-button size="mini" style="width: 5rem;">取消</el-button>
							<el-button type="primary" @click="submitParam" style="margin-left: 1.875rem;width: 5rem;" size="mini">发布</el-button>
						</div>
					</div>
				</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default{
		data(){
			return{
				cur_left_tab:1,
				left_tab_list:[
					{name:'进行中',state:1},
					{name:'已完成',state:2}
				],
				zpType:[
					{label:'医疗美容类',value:'0'}
				],
				zmType:[
					{label:'直接合作',value:'0'},
					{label:'直接合作+推荐合作',value:'1'}
				],
				paramData:{
					mould_id:'',/*mould_id，编辑使用*/
					mould_title:'',/*商品标题*/
					mould_img:'',/*商品图片*/
					problem_items:'',/*,问题集，用英文逗号隔开*/
					try_time:'',/*体验时间*/
					other_tip_word:'',/*温馨提示(文字)*/
					other_tip_img:[],/*温馨提示(照片)*/
					other_mould:[]/*添加的其他模块，json化：title和value的数组*/
				},
				cur_category:{
					cat_id:'',
					cat_name:'',
					cat_title:'',
					problem_items:''
				},
				cooperate_list:[],/*列表*/
				cat_title:'',
				cur_problem:'',
				problem_items:[]
			}
		},
		methods:{
			tabTap(item,index){
				this.cur_left_tab=item.state
				this.admin_get_report_mould_list()
			},
			selProblem(item,index){
				this.problem_items[index].checked=!this.problem_items[index].checked
			},
			admin_get_report_mould_list(){
				let params = {
					act:'admin_get_report_mould_list',
					token: localStorage.getItem('token'),
					user_id: localStorage.getItem('user_id'),
					page:1,
					size:100
				}
				this.$api.admin_get_report_mould_list(params).then((res)=>{
					this.cooperate_list = res.data
				})
			},
			fileSuccessImg(res){
				this.paramData.mould_img = this.$apiurl + res.data
			},
			fileSuccessOtherimg(res){
				this.paramData.other_tip_img.push(this.$apiurl + res.data)
			},
			addOthermould(){
				this.paramData.other_mould.push({title:'',value:''})
			},
			delOtherMould(item,index){
				this.paramData.other_mould.splice(index,1)
			},
			submitParam(){
				if(this.paramData.mould_title==''){
					this.$message({
						showClose: false,
						message: '请填写模板标题',
						type: 'warning',
						offset: 350
					})
					return
				}
				if(this.paramData.mould_img==''){
					this.$message({
						showClose: false,
						message: '请上传模板封面图',
						type: 'warning',
						offset: 350
					})
					return
				}
				if(this.paramData.try_time==''){
					this.$message({
						showClose: false,
						message: '请选择体验时间',
						type: 'warning',
						offset: 350
					})
					return
				}
				if(this.paramData.other_tip_word==''){
					this.$message({
						showClose: false,
						message: '请填写提示文字',
						type: 'warning',
						offset: 350
					})
					return
				}
				let arr1 = []
				this.paramData.other_mould.forEach((v1)=>{
					if(v1.title!='' && v1.value !=''){
						arr1.push({...v1})
					}
				})
				let params = {
					act:'admin_save_report_mould_info',
					token: localStorage.getItem('token'),
					user_id: localStorage.getItem('user_id'),
					mould_id:this.paramData.mould_id,
					mould_title: this.paramData.mould_title,
					mould_img: this.paramData.mould_img,
					try_time: this.paramData.try_time,
					other_tip_word: this.paramData.other_tip_word,
					other_tip_img: this.paramData.other_tip_img.join(','),
					other_mould:JSON.stringify(arr1)
				}
				this.$api.admin_save_report_mould_info(params).then((res)=>{
					if(res.code == 0){
						this.$message({
							showClose: false,
							message: '发布成功',
							type: 'success',
							offset: 350
						})
						this.paramData={
							mould_id:'',/*mould_id，编辑使用*/
							mould_title:'',/*商品标题*/
							mould_img:'',/*商品图片*/
							problem_items:'',/*,问题集，用英文逗号隔开*/
							try_time:'',/*体验时间*/
							other_tip_word:'',/*温馨提示(文字)*/
							other_tip_img:[],/*温馨提示(照片)*/
							other_mould:[]/*添加的其他模块，json化：title和value的数组*/
						}
						this.admin_get_report_mould_list()
					}else{
						this.$message({
							showClose: false,
							message: res.msg,
							type: 'error',
							offset: 350
						})
					}
				})
			},
			editCooperate(item,index){
				this.paramData = item
			},
			delCooperate(item,index){
				let params = {
					act:'admin_del_report',
					token: localStorage.getItem('token'),
					user_id: localStorage.getItem('user_id'),
					id:item.mould_id,
					id_type:0
				}
				this.$api.admin_del_report(params).then((res)=>{
					if(res.code == 0){
						this.$message({
							showClose: false,
							message: '操作成功',
							type: 'success',
							offset: 350
						})
						this.cooperate_list.splice(index,1)
					}else{
						this.$message({
							showClose: false,
							message: res.msg,
							type: 'error',
							offset: 350
						})
					}
				})
			},
			watchDetail(item,index){
				this.$router.push({path:'fk_repost_detail',query:item})
			}
		},
		created() {
			if(this.$route.query.coo_id){
				this.paramData=this.$route.query
			}
			this.admin_get_report_mould_list()
		}
	}
</script>

<style scoped>
	.sel-active{
		background-color: #409EFF;
		color: #FFFFFF;
	}
	.sel-pt{
		background-color: #EEEEEE;
		color: #888888;
	}
	.content-box{
		width: 85rem;
		min-height: 55rem;
		display: flex;
		justify-content: space-between;
		box-sizing: border-box;
	}
	.content-left-box{
		width: 20rem;
		height: 100%;
		background: #FFFFFF;
		border-radius: 0.625rem;
		box-sizing: border-box;
		/* padding: 1.25rem; */
		font-size: 1rem;
		color: #888888;
		font-weight: 600;
	}
	.content-right-box{
		width: 64rem;
		height: 100%;
		background: #FFFFFF;
		border-radius: 0.625rem;
		box-sizing: border-box;
		padding: 1.5rem 0 1.5rem 0;
		display: flex;
		justify-content: center;
	}
	
	.avatar-uploader .el-upload {
	    border: 0.0625rem dashed #BBBBBB;
	    border-radius: 6px;
	    cursor: pointer;
	    position: relative;
	    overflow: hidden;
	}
	.avatar-uploader >>>.el-upload{
		display: flex !important;
	}
	.avatar-uploader .el-upload:hover {
	    border-color: #409EFF;
	}
	.avatar-uploader-icon {
		border: 0.0625rem dashed #BBBBBB;
	    font-size: 28px;
	    color: #8c939d;
	    width: 7.5rem;
	    height: 7.5rem;
	    line-height: 7.5rem;
	    text-align: center;
		border-radius: 6px;
	}
	.avatar-uploader .avatar-uploader-icon:hover {
	    border-color: #409EFF;
	}
	.avatar {
	    width: 7.5rem;
	    height: 7.5rem;
		border-radius: 6px;
	    display: block;
	}
	.img-box::-webkit-scrollbar{
		  display: none;
	}
	.list-boxs::-webkit-scrollbar{
		background: #BBBBBB;
		width: 5px;
	}
	.list-boxs::-webkit-scrollbar-thumb {
		/*滚动条里面的条*/
		border-radius: 10px;
		box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
		background: #BBBBBB;
		width: 5px;
	}
	.ques::after{
		content: '';
		width: 70px;
		height: 24px;
	}
	.other-img::after{
		content: '';
		width: 80px;
		height: 80px;
	}
</style>